// for use in scripts/generateFromParts.js

const parts = [// Top
  `<svg width="420" height="420" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <a target="_blank" href="https://app.opendollar.com/vaults/`, `">
    <style>
      .graph-bg {
        fill: none;
        stroke: #000;
        stroke-width: 20;
        opacity: 80%;
      }

      .graph {
        fill: none;
        stroke-width: 20;
        stroke-linecap: flat;
        animation: progress 1s ease-out forwards;
      }

      .chart {
        stroke: `, `;
        opacity: 40%;
      }

      .risk-ratio {
        fill: `, `;
      }

      @keyframes progress {
        0% {
          stroke-dasharray: 0 1005;
        }
      }

      @keyframes liquidation {
        0% {
          opacity: 80%;
        }

        50% {
          opacity: 20%;
        }

        100 {
          opacity: 80%;
        }
      }
    </style>
    <g font-family="Inter, Verdana, sans-serif" style="white-space:pre" font-size="12">
      <path fill="#001828" d="M0 0H420V420H0z" />
      <path fill="url(#gradient)" d="M0 0H420V420H0z" />
      <path id="od-pattern-tile" opacity=".05" d="M49.7-40a145 145 0 1 0 0 290m0-290V8.2m0-48.4a145 145 0 1 1 0 290m0-241.6a96.7 96.7 0 1 0 0 193.3m0-193.3a96.7 96.7 0 1 1 0 193.3m0 0v48.3m0-96.6a48.3 48.3 0 0 0 0-96.7v96.7Zm0 0a48.3 48.3 0 0 1 0-96.7v96.7Z" stroke="#fff" />
      <use xlink:href="#od-pattern-tile" x="290" />
      <use xlink:href="#od-pattern-tile" y="290" />
      <use xlink:href="#od-pattern-tile" x="290" y="290" />
      <use xlink:href="#od-pattern-tile" x="193" y="145" />
      <text fill="#00587E" xml:space="preserve">
        <tspan x="24" y="40.7">VAULT ID</tspan>
      </text>
      <text fill="#1499DA" xml:space="preserve" font-size="22">
        <tspan x="24" y="65">`, `</tspan>
      </text>
      <text fill="#00587E" xml:space="preserve">
        <tspan x="315.9" y="40.7">STABILITY FEE</tspan>
      </text>
      <text fill="#1499DA" xml:space="preserve" font-size="22">
        <tspan x="443" y="63.3" text-anchor="end">`, `</tspan>
      </text>
      <text opacity=".3" transform="rotate(90 -66.5 101.5)" fill="#fff" xml:space="preserve" font-size="10">
        <tspan x=".5" y="7.3">opendollar.com</tspan>
      </text>
      <text `, `fill="#00587E" xml:space="preserve" font-weight="600">
        <tspan x="102" y="168.9">DEBT</tspan>
      </text>
      <text fill="#D0F1FF" xml:space="preserve" font-size="24">
        <tspan x="102" y="194">`, `</tspan>
      </text>
      <text fill="#00587E" xml:space="preserve" font-weight="600">
        <tspan x="102" y="229.9">COLLATERAL</tspan>
      </text>
      <text fill="#D0F1FF" xml:space="preserve" font-size="24">
        <tspan x="102" y="255">`, `</tspan>
      </text>
      <text opacity=".3" transform="rotate(-90 326.5 -58.5)" fill="#fff" xml:space="preserve" font-size="10">
        <tspan x="-10.3" y="7.3">Updated `, `</tspan>
      </text>
      <g opacity=".6">
        <text fill="#fff" xml:space="preserve">
          <tspan x="24" y="387.4">Powered by</tspan>
        </text>
        <path d="M112.5 388c-2 0-3-1.2-3-3.2v-3.3c0-2 1-3.3 3-3.3 2.1 0 3.2 1.3 3.2 3.3v3.3c0 2-1 3.3-3.2 3.3Zm-1.5-3.2c0 1.1.5 1.8 1.6 1.8 1 0 1.5-.7 1.5-1.8v-3.3c0-1.1-.4-1.8-1.5-1.8s-1.6.7-1.6 1.8v3.3ZM117.3 390.6l-.1-.2V381l.1-.2h1.2l.1.2v.7c.3-.7 1-1 1.8-1 1.3 0 2 1 2 2.6v2.3c0 1.6-.8 2.6-2 2.6-.8 0-1.4-.4-1.7-1v3.3c0 .1 0 .2-.2.2h-1.2Zm1.4-5.2c0 .9.5 1.3 1.1 1.3.7 0 1-.5 1-1.3v-2.2c0-.7-.3-1.3-1-1.3-.6 0-1.1.5-1.1 1.4v2ZM126.2 388c-1.6 0-2.6-1-2.6-2.6v-2.2c0-1.6 1-2.6 2.5-2.6 1.6 0 2.6 1 2.6 2.6v1.4c0 .1 0 .2-.2.2h-3.4v.6c0 1 .4 1.4 1.1 1.4.6 0 1-.3 1.1-.8l.2-.2 1 .3c.1 0 .2 0 .1.2-.2 1-1 1.8-2.4 1.8Zm-1.1-4.2h2.2v-.7c0-.8-.4-1.3-1.1-1.3-.8 0-1.1.5-1.1 1.3v.7ZM130.2 388l-.2-.2v-7l.2-.1h1.1c.1 0 .2 0 .2.2v.7c.4-.7 1-1 1.7-1 1.1 0 1.8.8 1.8 2.5v4.7l-.1.1h-1.2l-.2-.1V383c0-.8-.3-1.2-.8-1.2s-1 .4-1.2 1v4.9l-.1.1h-1.2ZM136.8 388l-.2-.2v-9.3c0-.1 0-.2.2-.2h2.6c2 0 3.1 1.3 3.1 3.3v3c0 2-1 3.3-3.1 3.3h-2.6Zm1.4-1.5h1.2c1 0 1.6-.7 1.6-1.8v-3c0-1.2-.5-1.9-1.6-1.9h-1.2v6.7ZM146.4 388c-1.6 0-2.6-1-2.6-2.6v-2.2c0-1.6 1-2.6 2.6-2.6 1.7 0 2.6 1 2.6 2.6v2.2c0 1.7-1 2.7-2.6 2.7Zm-1-2.6c0 .9.3 1.3 1 1.3.8 0 1.1-.4 1.1-1.3v-2.2c0-.8-.4-1.3-1-1.3-.8 0-1.1.5-1.1 1.3v2.2ZM150.6 388l-.2-.2V378l.2-.2h1.2l.2.2v9.7l-.2.1h-1.2ZM153.7 388l-.2-.2V378c0-.1 0-.2.2-.2h1.2l.1.2v9.7l-.1.1h-1.2ZM160 388l-.1-.2v-.8c-.4.7-1 1-1.7 1-1.1 0-1.9-.7-1.9-2 0-1.4.7-2.3 2.6-2.3h1v-.8c0-.7-.4-1-1-1s-.8.2-1 .8h-.2l-1-.2c-.1 0-.2-.1-.1-.2.2-1 1-1.7 2.4-1.7 1.5 0 2.3.7 2.3 2.2v5l-.2.1h-1Zm-2.3-2.2c0 .7.3 1 1 1 .5 0 1-.3 1.1-1v-1.1h-.8c-.8 0-1.3.4-1.3 1.1ZM163 388l-.2-.2v-7h1.5v1c.3-.7.9-1.2 1.8-1.2.1 0 .2 0 .2.2v1.1c0 .1 0 .2-.2.2-1 0-1.5.3-1.8 1v4.7l-.1.1H163Z" fill="#fff" />
        <path d="M97 383.2c0-2.7 2-4.8 4.7-4.8v1.6a3.2 3.2 0 0 0-3.1 3.2c0 1.8 1.4 3.2 3 3.2v1.6a4.7 4.7 0 0 1-4.6-4.8ZM101.7 384.8c.8 0 1.5-.7 1.5-1.6 0-.9-.7-1.6-1.5-1.6v3.2Z" fill="#fff" opacity=".5" />
        <path d="M106.3 383.2c0 2.7-2 4.8-4.6 4.8v-1.6c1.7 0 3-1.4 3-3.2 0-1.8-1.3-3.2-3-3.2v-1.6c2.6 0 4.6 2.1 4.6 4.8ZM101.7 381.6c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6v-3.2Z" fill="#fff" />
      </g>
      <g class="chart">
        <path class="graph-bg" d="M210 40a160 160 0 0 1 0 320 160 160 0 0 1 0-320" />
        <!-- Chart Percentage -->
        <path class="graph" stroke-dasharray="calc(1005 * `, `), 1005" d="M210 40a160 160 0 0 1 0 320 160 160 0 0 1 0-320" />
      </g>
      <g class="risk-ratio">
        <rect `, `x="242" y="306" width="154" height="82" rx="8" fill="#001828" fill-opacity=".7" />
        <circle cx="243" cy="326.5" r="4" />
        <text xml:space="preserve" font-weight="600">
          <tspan x="255" y="330.7">`, ` RISK`, `</tspan>
        </text>
        <text xml:space="preserve">
          <tspan x="255" y="355.7">COLLATERAL</tspan>
          <tspan x="255" y="371.7">RATIO `, `</tspan>
        </text>
      </g>
    </g>
    <defs>
      <!-- Gradient -->
      <radialGradient id="gradient" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-133.2 301 119) scale(368.295)"><stop stop-color="`, `" /><stop offset="1" stop-color="`, `" stop-opacity="0" /></radialGradient>
    </defs>
  </a>
</svg>`,];

export { parts };
